import React, { Component } from 'react';
import axios from 'axios';
import createPlotlyComponent from 'react-plotly.js/factory';
import backend_url from "../../../../routes/API_URL";
import swal from 'sweetalert';

const API_URL = backend_url['api_url'];
var Plotly = require('plotly.js');
var Plot = createPlotlyComponent(Plotly);

class InspectedSchools extends Component {
	constructor(props) {
		super(props);
		const year_id = props.year_id;
		const current_date = new Date();
		const current_year = current_date.getFullYear();

		this.state = {
			Graph_Data: [],
			year: year_id,
			current_year: current_year,
			school_id: window.sessionStorage.getItem("school_id"),
			bearer_auth: window.sessionStorage.getItem('token'),
			loading: true,
			error: null
		};
	}

	componentDidMount() {
		this.fetchSchoolInspectionStats();
	}

	fetchSchoolInspectionStats = () => {
		const { school_id, bearer_auth } = this.state;
		
		// Validate school_id
		if (!school_id || school_id === 'undefined' || school_id === 'null' || school_id === '') {
			this.setState({ 
				error: 'No valid school ID found',
				loading: false 
			});
			return;
		}
		
		this.setState({ loading: true, error: null });
		
		axios.get(`${API_URL}/school_inspection_stats/${school_id}`, 
			{ headers: { "Authorization": `Bearer ${bearer_auth}` }}
		).then(response => {
			const data = response.data.data || [];
			this.setState({
				Graph_Data: data,
				loading: false
			});
		}).catch(error => {
			console.error('Error fetching school inspection stats:', error);
			
			if (error.response?.status === 401) {
				swal({
					title: "Session Expired",
					text: "Your session has expired. Please log in again.",
					icon: "warning",
					timer: 2000
				}).then(() => {
					window.sessionStorage.clear();
					window.location.href = '/login';
				});
			} else {
				this.setState({ 
					error: 'Failed to load inspection statistics',
					loading: false 
				});
				swal({
					title: "Error",
					text: "Failed to load inspection statistics",
					icon: "error",
					timer: 3000
				});
			}
		});
	}

	render() {
		const { Graph_Data, school_id, loading, error, current_year } = this.state;

		// Show loading state
		if (loading) {
			return (
				<div className="text-center p-5">
					<div className="spinner-border text-primary" role="status">
						<span className="sr-only">Loading...</span>
					</div>
					<p className="mt-2">Loading inspection statistics...</p>
				</div>
			);
		}

		// Show error state
		if (error) {
			return (
				<div className="text-center p-5">
					<h5 className="text-danger">{error}</h5>
					<p>Unable to load inspection data for this school.</p>
				</div>
			);
		}

		// Validate school_id
		if (!school_id || school_id === 'undefined' || school_id === 'null' || school_id === '') {
			return (
				<div className="text-center p-5">
					<h5 className="text-warning">No School ID Available</h5>
					<p>Please log in again to access school data.</p>
				</div>
			);
		}

		// Show empty state if no data
		if (!Graph_Data || Graph_Data.length === 0) {
			return (
				<div className="text-center p-5">
					<h5>No Inspection Data Available</h5>
					<p>This school has not been inspected yet.</p>
				</div>
			);
		}

		// Process data for chart
		const years = [];
		for (let i = 0; i < Graph_Data.length; i++) {
			years.push(Graph_Data[i]['YEAR']);
		}
		const unique_years = [...new Set(years)].sort();

		// Prepare data series
		let primaryData = { 
			type: 'bar', 
			mode: 'group', 
			x: [], 
			y: [], 
			text: [], 
			name: 'Primary Schools',
			marker: { color: '#3498db' }
		};
		
		let secondaryData = { 
			type: 'bar', 
			mode: 'group', 
			x: [], 
			y: [], 
			text: [], 
			name: 'Secondary Schools',
			marker: { color: '#e74c3c' }
		};

		// Filter last 10 years of data
		for (let i = 0; i < Graph_Data.length; i++) {
			const year = Graph_Data[i]['YEAR'];
			const yearDiff = current_year - parseInt(year);
			
			if (yearDiff < 10 && yearDiff >= 0) {
				if (Graph_Data[i]['sector_id'] == '1') {
					primaryData.x.push(year);
					primaryData.y.push(Graph_Data[i]['visit_count'] || 0);
					primaryData.text.push("Primary School Visits");
				} else if (Graph_Data[i]['sector_id'] == '2') {
					secondaryData.x.push(year);
					secondaryData.y.push(Graph_Data[i]['visit_count'] || 0);
					secondaryData.text.push("Secondary School Visits");
				}
			}
		}

		// Only include data series that have data
		const chartData = [];
		if (primaryData.x.length > 0) chartData.push(primaryData);
		if (secondaryData.x.length > 0) chartData.push(secondaryData);

		// If no data after filtering, show message
		if (chartData.length === 0) {
			return (
				<div className="text-center p-5">
					<h5>No Recent Inspection Data</h5>
					<p>No inspection data available for the last 10 years.</p>
				</div>
			);
		}

		const layout = {
			title: "SCHOOL INSPECTION STATISTICS (Last 10 Years)",
			autosize: true,
			xaxis: {
				type: 'category',
				title: 'YEAR',
				categoryorder: "array",
				categoryarray: unique_years,
				tickangle: -45
			},
			yaxis: {
				title: 'NUMBER OF INSPECTIONS',
				align: 'center',
				zeroline: true
			},
			bargap: 0.15,
			bargroupgap: 0.1,
			legend: {
				orientation: 'h',
				y: -0.2,
				x: 0.5,
				xanchor: 'center'
			},
			margin: {
				l: 60,
				r: 40,
				b: 80,
				t: 80,
				pad: 4
			}
		};

		const style = { width: "100%", height: "400px" };

		return (
			<React.Fragment>
				<Plot
					data={chartData}
					layout={layout}
					useResizeHandler={true}
					style={style}
					config={{
						responsive: true,
						displaylogo: false,
						modeBarButtonsToRemove: ['sendDataToCloud', 'zoom2d', 'pan2d', 'select2d', 'lasso2d', 'zoomIn2d', 'zoomOut2d', 'autoScale2d', 'resetScale2d']
					}}
				/>
			</React.Fragment>
		);
	}
}

export default InspectedSchools;